import {
  OperatingHoursOfDay,
  OperatingHoursProperty,
  WcsPhysicalStoreAttribute,
} from '@/scripts/libs/physical-stores/types/wcs-interfaces'
import { DistributionChannel, StoreBrandEU } from '@/scripts/libs/physical-stores/types/enums'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import wcs from '@/scripts/libs/wcs'

const { storeId } = wcs.getStoreConfig()
const weekArrayClosed = [
  'closeMonday',
  'closeTuesday',
  'closeWednesday',
  'closeThursday',
  'closeFriday',
  'closeSaturday',
  'closeSunday',
]
const weekArrayOpened = [
  'openMonday',
  'openTuesday',
  'openWednesday',
  'openThursday',
  'openFriday',
  'openSaturday',
  'openSunday',
]
const defaultHourForClosedStore = '00:00'
const closedIndicatorProperty = 'ClosedIndicator'
const colonSymbol = ':'
const zeroSymbol = '0'

export default class PhysicalStoresEU {
  static mapStoreBrandForEU = (distributionChannel: string) => {
    switch (distributionChannel) {
      case DistributionChannel.LENS_CRAFTERS:
        /* TODO: rename this enum to StoreBrand and detach from EU context */
        return StoreBrandEU.LENS_CRAFTERS
      case DistributionChannel.RAY_BAN:
        /* TODO: rename this enum to StoreBrand and detach from EU context */
        return StoreBrandEU.RAY_BAN
      case DistributionChannel.SGH:
        /* TODO: rename this enum to StoreBrand and detach from EU context */
        return StoreBrandEU.SUNGLASS_HUT
      default:
        /* TODO: rename this enum to StoreBrand and detach from EU context */
        return StoreBrandEU.OTHER
    }
  }

  static getTimeZoneForUPSStore = () => {
    const SpainTimeZone = 'Europe/Amsterdam'
    const UnitedKingdomTimeZone = 'Etc/GMT-0'

    switch (storeId) {
      case WcsStoreId.ITALY:
      case WcsStoreId.SPAIN:
        return SpainTimeZone
      case WcsStoreId.UNITED_KINGDOM:
        return UnitedKingdomTimeZone
      default:
        return UnitedKingdomTimeZone
    }
  }

  static getUPSAttributesForHoursArray = (dayOfWeekArray: OperatingHoursOfDay[]) => {
    const openHourArray: WcsPhysicalStoreAttribute[] = []
    const closeHourArray: WcsPhysicalStoreAttribute[] = []

    dayOfWeekArray.forEach((day) => {
      openHourArray.push(PhysicalStoresEU.getOpenHoursArrayElement(day))
      closeHourArray.push(PhysicalStoresEU.getCloseHoursArrayElement(day))
    })

    return [...openHourArray, ...closeHourArray]
  }

  private static getOpenHoursArrayElement = (day: OperatingHoursOfDay) => {
    const name = PhysicalStoresEU.getName(day.Day, weekArrayOpened)
    const value =
      closedIndicatorProperty in day
        ? defaultHourForClosedStore
        : PhysicalStoresEU.getValue(day.OpenHours, 0)

    const openHoursAttribute: WcsPhysicalStoreAttribute = {
      name,
      value,
      displayName: name,
      displayValue: value,
    }

    return openHoursAttribute
  }

  private static getCloseHoursArrayElement = (day: OperatingHoursOfDay) => {
    const name = PhysicalStoresEU.getName(day.Day, weekArrayClosed)
    const value =
      closedIndicatorProperty in day
        ? defaultHourForClosedStore
        : PhysicalStoresEU.getValue(day.CloseHours, 1)

    const closeHoursAttribute: WcsPhysicalStoreAttribute = {
      name,
      value,
      displayName: name,
      displayValue: value,
    }

    return closeHoursAttribute
  }

  private static getName = (day: number, weekDaysArray: string[]) => {
    switch (day) {
      case 1:
        return weekDaysArray[6]
      case 2:
        return weekDaysArray[0]
      case 3:
        return weekDaysArray[1]
      case 4:
        return weekDaysArray[2]
      case 5:
        return weekDaysArray[3]
      case 6:
        return weekDaysArray[4]
      case 7:
        return weekDaysArray[5]
      default:
        return ''
    }
  }

  private static getValue = (dayHours: OperatingHoursProperty = 0, index: number) => {
    if (dayHours === 0) return ''

    const openingHour = typeof dayHours === 'number' ? String(dayHours) : String(dayHours[index])
    const splitIndex = openingHour.length === 3 ? 1 : 2

    const hour = openingHour.slice(0, splitIndex)
    const minute = openingHour.slice(splitIndex)
    const formattedHour = hour.length === 1 ? `${zeroSymbol}${hour}` : hour

    const formattedOperatingHours = `${formattedHour}${colonSymbol}${minute}`
    return formattedOperatingHours
  }
}
